import { GetFeatureThemaListResponce } from './api-services/get-feature-thema-list.service';
import { KYMW1301Component } from './kymw1301.component';

/**
 * 企画書データ出力画面の値を管理するクラス
 *
 * @export KYMW1301Model
 * @class KYMW1301Model
 */
export class KYMW1301Model {

  kymw1301Component: KYMW1301Component;

  // 画面バインド用変数
  /** 受注コード（開始） */
  public orderCodeFrom: string = <string>'';
  /** 受注コード（終了） */
  public orderCodeTo: string = <string>'';
  /** 媒体区分 */
  public mediumType: string = <string>'';
  /** Pコード */
  public pCode: string = <string>'';
  /** 生協コード */
  public coopCode: string = <string>'';
  /** 出力開始ページ */
  public pageNumFrom: string = <string>'';
  /** 出力終了ページ */
  public pageNumTo: string = <string>'';
  /** 注文コード */
  public orderNum: string = <string>'';
  /** 特集コード 選択用 */
  public selectFeatureCode: string = <string>''; 
  // マークコード
  markCode1: string = <string>'';
  markCode2: string = <string>'';
  markCode3: string = <string>'';
  markCode4: string = <string>'';
  markCode5: string = <string>'';
  /** W掲載除外フラグ */
  wPublishFlag: boolean = <boolean>false;
  /** W掲載フラグ */
  multiPublishFlag: boolean = <boolean>false;

  /** 特集コード セレクト用リスト */
  public featureThemaList: { 
    featureCode: string; 
    featureName: string 
  }[];

  /**
   * 特集コード セレクトボックスを設定
   * @param data 
   */
  public setfeatureThemaList(data: GetFeatureThemaListResponce) {
    this.featureThemaList = data.map(_ => ({
      featureCode: _.FeatureCode,
      featureName: _.FeatureName,
    }));
  }
}